import React from 'react';
import { Search, Edit, FileText, LogIn, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Link } from 'react-router-dom';
export function SearchUser() {
  const users = [{
    id: 1,
    username: 'jdoe',
    fullName: 'John Doe',
    email: 'john@example.com',
    courses: 2,
    notes: 'VIP Client',
    lastLogin: '2023-10-25 14:30'
  }, {
    id: 2,
    username: 'asmith',
    fullName: 'Alice Smith',
    email: 'alice@example.com',
    courses: 1,
    notes: '',
    lastLogin: '2023-11-01 09:15'
  }, {
    id: 3,
    username: 'bwilson',
    fullName: 'Bob Wilson',
    email: 'bob@example.com',
    courses: 0,
    notes: 'Pending payment',
    lastLogin: 'Never'
  }];
  return <div className="space-y-6" data-id="element-707">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-708">Search User</h1>

      <Card className="p-4" data-id="element-709">
        <div className="flex flex-col md:flex-row gap-4 items-end" data-id="element-710">
          <div className="w-full md:w-1/3" data-id="element-711">
            <Input label="Search" placeholder="Enter keyword..." data-id="element-712" />
          </div>
          <div className="w-full md:w-1/3" data-id="element-713">
            <Select label="Search By" options={[{
            value: 'name',
            label: 'Name'
          }, {
            value: 'email',
            label: 'Email'
          }, {
            value: 'username',
            label: 'Username'
          }, {
            value: 'company',
            label: 'Company'
          }]} data-id="element-714" />
          </div>
          <Button variant="secondary" className="gap-2 w-full md:w-auto" data-id="element-715">
            <Search className="h-4 w-4" data-id="element-716" />
            Search
          </Button>
        </div>
      </Card>

      <Card className="overflow-hidden" data-id="element-717">
        <div className="overflow-x-auto" data-id="element-718">
          <table className="w-full text-sm text-left" data-id="element-719">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-720">
              <tr data-id="element-721">
                <th className="px-4 py-3" data-id="element-722">User Name</th>
                <th className="px-4 py-3" data-id="element-723">Full Name</th>
                <th className="px-4 py-3" data-id="element-724">Email</th>
                <th className="px-4 py-3" data-id="element-725">Available Courses</th>
                <th className="px-4 py-3" data-id="element-726">Notes</th>
                <th className="px-4 py-3" data-id="element-727">Last Login</th>
                <th className="px-4 py-3" data-id="element-728">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-729">
              {users.map(user => <tr key={user.id} className="hover:bg-slate-50" data-id="element-730">
                  <td className="px-4 py-3 font-medium" data-id="element-731">{user.username}</td>
                  <td className="px-4 py-3" data-id="element-732">{user.fullName}</td>
                  <td className="px-4 py-3" data-id="element-733">{user.email}</td>
                  <td className="px-4 py-3 text-center" data-id="element-734">{user.courses}</td>
                  <td className="px-4 py-3 text-slate-500 italic" data-id="element-735">
                    {user.notes}
                  </td>
                  <td className="px-4 py-3 text-slate-500" data-id="element-736">{user.lastLogin}</td>
                  <td className="px-4 py-3" data-id="element-737">
                    <div className="flex items-center gap-2" data-id="element-738">
                      <Link to={`/users/edit/${user.id}`} data-id="element-739">
                        <Button variant="ghost" size="icon" title="Edit" data-id="element-740">
                          <Edit className="h-4 w-4 text-blue-600" data-id="element-741" />
                        </Button>
                      </Link>
                      <Button variant="ghost" size="icon" title="Notes" data-id="element-742">
                        <FileText className="h-4 w-4 text-slate-500" data-id="element-743" />
                      </Button>
                      <Button variant="ghost" size="icon" title="Login as User" data-id="element-744">
                        <LogIn className="h-4 w-4 text-green-600" data-id="element-745" />
                      </Button>
                      <Button variant="ghost" size="icon" title="Delete" data-id="element-746">
                        <Trash2 className="h-4 w-4 text-red-600" data-id="element-747" />
                      </Button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}